import {
  formatPrice,
  getAvailablePrice,
  getBeforePromotionPrice,
  getCurrencySymbol,
  getPriceCurrencyOrder,
  replacePlaceholders,
  roundPrice,
} from '@msc-b2c/shared-utils';
import { Text } from '@msc-b2c/shared-components';
import clsx from 'clsx';

import './price.module.scss';
import { ShopExcursionDiscounDetailsI } from '@msc-b2c/interfaces/interfaces';

export const Price = ({
  passengerPrice,
  isPromotionAvailable,
}: {
  passengerPrice: ShopExcursionDiscounDetailsI | undefined;
  isPromotionAvailable: boolean;
}) => {
  const currency = getCurrencySymbol();
  return (
    <div className={'drawer-price'}>
      <Text
        text={replacePlaceholders(getPriceCurrencyOrder(), {
          currency: currency,
          price: formatPrice(roundPrice(getAvailablePrice(passengerPrice))),
        })}
        tagHtml="span"
        styleOption={clsx('drawer-price__after-discount', {
          'drawer-price__after-discount-promotion': isPromotionAvailable,
        })}
      />
      {isPromotionAvailable && (
        <Text
          text={replacePlaceholders(getPriceCurrencyOrder(), {
            currency: currency,
            price: formatPrice(roundPrice(getBeforePromotionPrice(passengerPrice) ?? '')),
          })}
          tagHtml="span"
          styleOption={'drawer-price__before-discount-promotion'}
        />
      )}
    </div>
  );
};
